import { isExampleResource } from '@gonfalon/analytics/isExampleResource';
import { matchFlags, matchFlagTargeting } from '@gonfalon/navigator/matchers';
import type { AnyAction } from 'redux';
import type { StateObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { ignoreElements, tap } from 'rxjs';

import { flags as flagActionTypes } from '#actionTypes/flags';
import registry from '#epics/registry';
import { currentEnvironmentSelector } from '#reducers/projects';
import { pathnameSelector } from '#reducers/router';
import type { GlobalState } from '#reducers/state';
import { EventLocation } from '#utils/analyticsUtils';
import { trackFlagListEvent, trackFlagTargetingEvent } from '#utils/flags/flagAnalytics';

export function trackFlagToggleUpdateEvents(action$: Observable<AnyAction>, state$: StateObservable<GlobalState>) {
  return action$.pipe(
    ofType(flagActionTypes.UPDATE_FLAG),
    tap(({ oldFlag, newFlag }) => {
      const pathname = pathnameSelector(state$.value);
      const environment = currentEnvironmentSelector(state$.value).get('entity');

      const isFlagDashboard = matchFlags(pathname);
      const isFlagTargeting = matchFlagTargeting(pathname);

      // We only care about "on" changes, and ignore irrelevant flag changes
      if (oldFlag.isOn(environment.key) === newFlag.isOn(environment.key)) {
        return;
      }

      let location: EventLocation;
      if (isFlagDashboard) {
        location = EventLocation.FLAG_LIST;
      } else if (isFlagTargeting) {
        location = EventLocation.FLAG_TARGETING;
      } else {
        return;
      }

      let track;
      if (isFlagDashboard) {
        track = trackFlagListEvent;
      } else if (isFlagTargeting) {
        track = trackFlagTargetingEvent;
      } else {
        return;
      }

      track('Feature Flag Toggled', {
        toggleActioned: newFlag.isOn(environment.key) ? 'on' : 'off',
        location,
        isExampleResource: isExampleResource(newFlag.key),
      });
    }),
    ignoreElements(),
  );
}

registry.addEpics([trackFlagToggleUpdateEvents]);
